type IconProps = React.HTMLAttributes<SVGElement> & {
  color?: string;
};

export const Icons = {
  Spinner: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
  X: (props: IconProps) => (
    <svg
      width="44"
      height="41"
      viewBox="0 0 44 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.6526 0.8078H41.3995L26.6594 17.6548L44 40.5797H30.4225L19.7881 26.6759L7.61989 40.5797H0.868864L16.6349 22.56L0 0.8078H13.9222L23.5348 13.5165L34.6526 0.8078ZM32.2846 36.5414H36.0232L11.8908 4.63406H7.87892L32.2846 36.5414Z"
        fill={props.color ?? "white"}
      />
    </svg>
  ),
  Discord: (props: IconProps) => (
    <svg
      width="48"
      height="37"
      viewBox="0 0 48 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M40.634 3.31127C37.5747 1.90751 34.294 0.873274 30.8638 0.280927C30.8013 0.269495 30.7389 0.298065 30.7067 0.355205C30.2848 1.10563 29.8175 2.08463 29.4902 2.85412C25.8008 2.30178 22.1304 2.30178 18.5166 2.85412C18.1893 2.06753 17.705 1.10563 17.2811 0.355205C17.249 0.299971 17.1866 0.271402 17.1241 0.280927C13.6958 0.871381 10.4151 1.90561 7.35387 3.31127C7.32737 3.32269 7.30465 3.34176 7.28958 3.3665C1.06678 12.6632 -0.6379 21.7314 0.19836 30.6872C0.202144 30.731 0.22674 30.7729 0.260796 30.7996C4.36642 33.8147 8.34341 35.6451 12.2466 36.8583C12.309 36.8774 12.3752 36.8546 12.415 36.8031C13.3383 35.5423 14.1613 34.2128 14.867 32.8147C14.9086 32.7328 14.8688 32.6357 14.7837 32.6033C13.4783 32.1081 12.2352 31.5043 11.0395 30.8187C10.9449 30.7634 10.9373 30.6281 11.0243 30.5634C11.2759 30.3748 11.5276 30.1786 11.7679 29.9805C11.8114 29.9444 11.872 29.9367 11.9231 29.9596C19.7786 33.5461 28.2831 33.5461 36.0459 29.9596C36.097 29.9348 36.1576 29.9425 36.203 29.9787C36.4433 30.1767 36.6949 30.3748 36.9484 30.5634C37.0354 30.6281 37.0298 30.7634 36.9352 30.8187C35.7394 31.5176 34.4964 32.1081 33.189 32.6014C33.1039 32.6338 33.0661 32.7328 33.1077 32.8147C33.8285 34.2108 34.6515 35.5403 35.5578 36.8012C35.5956 36.8546 35.6637 36.8774 35.7262 36.8583C39.6483 35.6451 43.6252 33.8147 47.7309 30.7996C47.7668 30.7729 47.7895 30.7329 47.7933 30.6891C48.7942 20.3352 46.117 11.3414 40.6964 3.3684C40.6832 3.34176 40.6605 3.32269 40.634 3.31127ZM16.04 25.2341C13.675 25.2341 11.7263 23.0628 11.7263 20.3962C11.7263 17.7297 13.6372 15.5584 16.04 15.5584C18.4617 15.5584 20.3916 17.7487 20.3538 20.3962C20.3538 23.0628 18.4428 25.2341 16.04 25.2341ZM31.9895 25.2341C29.6245 25.2341 27.6758 23.0628 27.6758 20.3962C27.6758 17.7297 29.5867 15.5584 31.9895 15.5584C34.4113 15.5584 36.3411 17.7487 36.3033 20.3962C36.3033 23.0628 34.4113 25.2341 31.9895 25.2341Z"
        fill={props.color ?? "white"}
      />
    </svg>
  ),
  Github: (props: IconProps) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_910_44)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.0199 0C10.7375 0 0 10.8167 0 24.1983C0 34.895 6.87988 43.9495 16.4241 47.1542C17.6174 47.3951 18.0545 46.6335 18.0545 45.9929C18.0545 45.4319 18.0151 43.509 18.0151 41.5055C11.3334 42.948 9.94198 38.6209 9.94198 38.6209C8.86818 35.8164 7.27715 35.0956 7.27715 35.0956C5.09022 33.6132 7.43645 33.6132 7.43645 33.6132C9.86233 33.7735 11.1353 36.0971 11.1353 36.0971C13.2824 39.7827 16.7422 38.7413 18.1341 38.1002C18.3328 36.5377 18.9695 35.456 19.6455 34.8552C14.3163 34.2942 8.70937 32.211 8.70937 22.9161C8.70937 20.2719 9.66321 18.1086 11.1746 16.4261C10.9361 15.8253 10.1008 13.3409 11.4135 10.0157C11.4135 10.0157 13.4417 9.3746 18.0146 12.4996C19.9725 11.9699 21.9916 11.7005 24.0199 11.6982C26.048 11.6982 28.1154 11.979 30.0246 12.4996C34.5981 9.3746 36.6262 10.0157 36.6262 10.0157C37.9389 13.3409 37.1031 15.8253 36.8646 16.4261C38.4158 18.1086 39.3303 20.2719 39.3303 22.9161C39.3303 32.211 33.7234 34.2539 28.3544 34.8552C29.2296 35.6163 29.9848 37.0583 29.9848 39.3421C29.9848 42.5871 29.9454 45.1915 29.9454 45.9924C29.9454 46.6335 30.383 47.3951 31.5758 47.1547C41.12 43.9491 47.9999 34.895 47.9999 24.1983C48.0392 10.8167 37.2624 0 24.0199 0Z"
          fill={props.color ?? "white"}
        />
      </g>
      <defs>
        <clipPath id="clip0_910_44">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Telegram: (props: IconProps) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_318_75)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM24.8601 17.7179C22.5257 18.6888 17.8603 20.6984 10.8638 23.7466C9.72766 24.1984 9.13251 24.6404 9.07834 25.0726C8.98677 25.803 9.90142 26.0906 11.1469 26.4822C11.3164 26.5355 11.4919 26.5907 11.6719 26.6492C12.8973 27.0475 14.5457 27.5135 15.4026 27.5321C16.1799 27.5489 17.0475 27.2284 18.0053 26.5707C24.5423 22.158 27.9168 19.9276 28.1286 19.8795C28.2781 19.8456 28.4852 19.803 28.6255 19.9277C28.7659 20.0524 28.7521 20.2886 28.7372 20.352C28.6466 20.7383 25.0562 24.0762 23.1982 25.8036C22.619 26.3421 22.2081 26.724 22.1242 26.8113C21.936 27.0067 21.7443 27.1915 21.56 27.3692C20.4215 28.4667 19.5678 29.2896 21.6072 30.6336C22.5873 31.2794 23.3715 31.8135 24.1539 32.3463C25.0084 32.9282 25.8606 33.5085 26.9632 34.2313C27.2442 34.4155 27.5125 34.6068 27.7738 34.7931C28.7681 35.5019 29.6615 36.1388 30.7652 36.0373C31.4065 35.9782 32.0689 35.3752 32.4053 33.5767C33.2004 29.3263 34.7633 20.1169 35.1244 16.3219C35.1561 15.9895 35.1163 15.5639 35.0843 15.3771C35.0523 15.1904 34.9855 14.9242 34.7427 14.7272C34.4552 14.4939 34.0113 14.4447 33.8127 14.4482C32.91 14.4641 31.5251 14.9456 24.8601 17.7179Z"
          fill={props.color ?? "white"}
        />
      </g>
      <defs>
        <clipPath id="clip0_318_75">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Logo: (props: IconProps) => (
    <svg
      {...props}
      width="391"
      height="344"
      viewBox="0 0 391 344"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M390.001 21C306.582 21 238.957 88.4926 238.957 171.749C238.957 255.005 306.582 322.498 390.001 322.498M0.589844 322.678C84.009 322.678 151.634 255.186 151.634 171.929C151.634 88.673 84.009 21.1805 0.589844 21.1805M1.00195 170H391.002"
        stroke="white"
        strokeWidth="42"
      />
    </svg>
  ),
  Send: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
      <path d="m21.854 2.147-10.94 10.939" />
    </svg>
  ),
};
